export type WhatsappTabKey = "general" | "compliance" | "automations";

export interface GetVisibleWhatsappTabsInput {
  compliance: boolean;
  automations: boolean;
}

/**
 * Ordered list of tabs to render on the WhatsApp detail page.
 *
 * "general" is always present. "compliance" and "automations" are each
 * independently gated, so the page must render the tab bar when *either*
 * one is on -- a binary "compliance on/off" check alone would leave
 * automations unreachable when compliance is off (and vice versa). Callers
 * decide whether to show the tab bar at all via `tabs.length > 1`.
 */
export function getVisibleWhatsappTabs({
  compliance,
  automations,
}: GetVisibleWhatsappTabsInput): Array<WhatsappTabKey> {
  const tabs: Array<WhatsappTabKey> = ["general"];
  if (compliance) tabs.push("compliance");
  if (automations) tabs.push("automations");
  return tabs;
}
